import React from 'react';

import { createTheme, Shadows, ThemeProvider } from '@mui/material';
import { atom_tourState } from '@app/shared/state/tour.atom';
import { useRecoilValue, selector } from 'recoil';

// Only re-renders when config changes, not on every tourState update
const selector_tourConfig = selector({
	key: 'tourConfig',
	get: ({ get }) => get(atom_tourState)?.config,
});

type ThemeProviderProps = {
	children?: React.ReactNode;
};

export const brandTheme = (config?: Record<string, string>) =>
	createTheme({
		shadows: Array(25).fill('none') as Shadows,
		palette: {
			primary: {
				main: config?.['mainColor'] || '#E14A1B',
			},
			secondary: {
				main: '#121A3E',
			},
		},
		typography: {
			allVariants: {
				fontFamily: 'Heebo',
				color: '#3C3A36',
			},
			h1: {
				fontSize: 35,
				fontWeight: 400,
			},
			h2: {
				fontSize: 20,
				fontWeight: 500,
			},
			caption: {
				fontSize: 12,
				fontWeight: 500,
				color: '#858585',
			},
			body1: {
				fontSize: 15,
				fontWeight: 500,
			},
			body2: {
				wordBreak: 'break-all',
				fontSize: 14,
				fontWeight: 400,
			},
			button: {
				fontSize: 16,
				fontWeight: 500,
				textTransform: 'none',
				lineHeight: '20px',
			},
		},
		components: {
			MuiTextField: {
				defaultProps: {
					multiline: true,
					maxRows: 1,
					minRows: 1,
					autoComplete: 'off',
				},
			},
			MuiButton: {
				defaultProps: {
					variant: 'contained',
				},
				styleOverrides: {
					root: () => ({
						borderRadius: 99999,
						color: '#48526B',
					}),
					contained: () => ({
						color: '#fff',
					}),
				},
			},
			MuiLink: {
				styleOverrides: {
					root: () => ({
						fontSize: 12,
						fontWeight: 500,
					}),
				},
			},
		},
	});

export const AppThemeProvider: React.FC<ThemeProviderProps> = (_p) => {
	const config = useRecoilValue(selector_tourConfig);
	return (
		<ThemeProvider theme={brandTheme(config)}>
			{_p.children}
		</ThemeProvider>
	);
};
